import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
import { AccesoEmail, AccesoEmailFav } from 'src/common/acceso';
import { EmailActions, EmailActionTypes } from './email.actions';

export interface EmailState extends EntityState<AccesoEmailFav> {
	personal: AccesoEmail,
    ready: boolean
}

export const emailAdapter: EntityAdapter<AccesoEmailFav> = createEntityAdapter<AccesoEmailFav>();

const initialEmailState: EmailState = emailAdapter.getInitialState({
	personal: null,
    ready: false,
    collapsed: false
});

export function emailReducer( state: EmailState = initialEmailState, action: EmailActions ): EmailState {
	let emailId: number;
	let readyUpdate: Update<AccesoEmailFav>;

    switch( action.type ) {
		case EmailActionTypes.EmailsRequested:
			return { ...state, ready: false };
		case EmailActionTypes.EmailsLoaded:
			// Agrego todos los emails que están en el payload
			// y seteo a todos el markedFromUI en false
            let emails = action["payload"];
			let personal: AccesoEmail = emails.personal;
			state = emailAdapter.addMany( emails.delegados, { ...state, personal, ready: true } );
			return emailAdapter.updateMany(
				(state.ids as number[]).map( id => {
					return { id: state.entities[ id ].id, changes: { markedFromUI: false } };
				}),
				state );
		case EmailActionTypes.EmailsCancelled:
		case EmailActionTypes.EmailsRight:
            return { ...state, ready: true };

		case EmailActionTypes.EmailToggleMarkedRequested:
			let acceso: AccesoEmailFav = action["payload"];
			readyUpdate = {
				id: acceso.id,
				changes: { ready: false }
			};
			return emailAdapter.updateOne( readyUpdate, { ...state, ready: false } );
		case EmailActionTypes.EmailToggleMarkedLoaded:
			emailId = action["payload"];
			const markedUpdate: Update<AccesoEmailFav> = {
				id: emailId,
				changes: { marked: !state.entities[ emailId ].marked, markedFromUI: true, ready: true }
			};
			return emailAdapter.updateOne( markedUpdate, { ...state, ready: true } );
		case EmailActionTypes.EmailToggleMarkedCancelled:
			emailId = action["payload"];
			readyUpdate = {
				id: emailId,
				changes: { ready: true }
			};
			return emailAdapter.updateOne( readyUpdate, { ...state, ready: true } );

		case EmailActionTypes.EmailFavInit:
			// Seteo todos los emails con markedFromUI en false
			return emailAdapter.updateMany(
				(state.ids as number[]).map( id => {
					return { id, changes: { markedFromUI: false } };
				}),
				state );

		case EmailActionTypes.EmailAccesoRequested:
			return { ...state, ready: false };
		case EmailActionTypes.EmailAccesoLoaded:
			return { ...state, ready: true }
		case EmailActionTypes.EmailAccesoCancelled:
			return { ...state, ready: true };

        default:
            return state;
    }
}

export const {
	selectAll
} = emailAdapter.getSelectors();
